// Neuromarketing content mapped per service category for landing pages
const LANDING_CONTENT = {
  "nettoyage-canape": {
    heroSub: "Votre canapé retrouve son éclat en 1 heure. Traitement professionnel par injection-extraction. Sans odeur, sans résidu.",
    pertinence: {
      title: "Votre canapé a besoin d'attention ?",
      points: [
        "Votre canapé a changé de couleur depuis l'achat",
        "Des taches résistent malgré vos tentatives",
        "Une odeur persiste même après aération",
        "Vos enfants ou animaux utilisent le canapé quotidiennement",
        "Vous n'osez plus recevoir des invités",
      ],
    },
    emotion: {
      title: "Ce que personne ne vous dit sur votre canapé",
      points: [
        "Un canapé non nettoyé contient jusqu'à 12'000 acariens par cm²",
        "Les bactéries se multiplient en silence dans les fibres",
        "La dégradation est progressive et irréversible sans traitement",
        "Le coût de remplacement d'un canapé : 2'000 à 5'000 CHF",
        "Le coût du nettoyage professionnel : une fraction du prix",
      ],
    },
    desir: {
      title: "Imaginez votre canapé comme au premier jour",
      points: [
        "Couleurs ravivées, fraîcheur retrouvée",
        "Plus aucune tache, plus aucune odeur",
        "Un intérieur dont vous êtes fier",
        "Des invités qui remarquent la différence",
        "L'assurance d'un environnement sain pour votre famille",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Diagnostic", desc: "Évaluation gratuite de votre canapé (tissu, état, taches)" },
        { num: "2", title: "Pré-traitement", desc: "Application d'un produit adapté à votre textile" },
        { num: "3", title: "Nettoyage", desc: "Injection-extraction professionnelle en profondeur" },
        { num: "4", title: "Contrôle", desc: "Vérification du résultat avec vous" },
      ],
      footer: "Intervention en ~1 heure • Séchage 3-4 heures • Sans danger pour enfants et animaux",
    },
  },
  "nettoyage-matelas": {
    heroSub: "Éliminez acariens, bactéries et odeurs. Retrouvez un sommeil sain dès ce soir.",
    pertinence: {
      title: "Votre matelas mérite mieux",
      points: [
        "Vous transpirez la nuit et le matelas absorbe tout",
        "Des taches apparaissent et résistent au nettoyage",
        "Une odeur désagréable persiste malgré les draps propres",
        "Vous souffrez d'allergies ou de problèmes respiratoires",
        "Votre matelas a plus de 6 mois sans nettoyage professionnel",
      ],
    },
    emotion: {
      title: "Ce que personne ne vous dit sur votre matelas",
      points: [
        "Vous passez 8 heures par nuit dans un nid à bactéries",
        "Un matelas double de poids en 10 ans à cause des acariens",
        "Les allergies nocturnes dégradent la qualité de votre sommeil",
        "Le coût d'un nouveau matelas : 1'000 à 3'000 CHF",
        "Le nettoyage professionnel : dès 120 CHF seulement",
      ],
    },
    desir: {
      title: "Imaginez un matelas parfaitement sain",
      points: [
        "Un sommeil réparateur, sans allergènes",
        "Aucune odeur, aucune tache",
        "La fraîcheur d'un matelas neuf",
        "Un environnement sain pour vos enfants",
        "L'esprit tranquille chaque nuit",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Diagnostic", desc: "Évaluation de votre matelas (taille, état, taches)" },
        { num: "2", title: "Aspiration", desc: "Aspiration profonde des acariens et poussières" },
        { num: "3", title: "Nettoyage", desc: "Injection-extraction éliminant bactéries et odeurs" },
        { num: "4", title: "Contrôle", desc: "Vérification du résultat — matelas utilisable le soir même" },
      ],
      footer: "Intervention en ~45 minutes • Séchage rapide • Matelas utilisable le soir même",
    },
  },
  "nettoyage-moquette": {
    heroSub: "Vos moquettes retrouvent leurs couleurs d'origine. Nettoyage en profondeur, résultat immédiat.",
    pertinence: {
      title: "Votre moquette montre des signes de fatigue ?",
      points: [
        "Les couleurs sont ternes et la moquette semble « sale »",
        "Des taches résistent à l'aspirateur et au shampoing",
        "Une odeur de renfermé persiste dans la pièce",
        "Vos enfants jouent au sol sur cette moquette",
        "L'image de vos locaux professionnels en souffre",
      ],
    },
    emotion: {
      title: "Ce que cache votre moquette",
      points: [
        "Les fibres emprisonnent poussières, allergènes et bactéries",
        "Un aspirateur n'élimine que 50% des saletés en surface",
        "Les acariens prolifèrent dans les moquettes mal entretenues",
        "Le coût de remplacement d'une moquette : 40 à 80 CHF/m²",
        "Le nettoyage professionnel : dès 5 CHF/m² seulement",
      ],
    },
    desir: {
      title: "Imaginez votre moquette comme neuve",
      points: [
        "Fibres ravivées, couleurs éclatantes",
        "Un air plus sain dans chaque pièce",
        "Des locaux dont vous êtes fier",
        "Une durée de vie prolongée de votre moquette",
        "Un environnement plus sain pour tous",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Diagnostic", desc: "Évaluation de la surface et du type de moquette" },
        { num: "2", title: "Pré-traitement", desc: "Traitement des taches tenaces" },
        { num: "3", title: "Nettoyage", desc: "Injection-extraction sur toute la surface" },
        { num: "4", title: "Contrôle", desc: "Vérification du résultat zone par zone" },
      ],
      footer: "Prix dégressif au m² • Séchage rapide • Idéal particuliers et entreprises",
    },
  },
  "nettoyage-tapis": {
    heroSub: "Nettoyage délicat adapté à chaque fibre. Vos tapis retrouvent couleurs et souplesse.",
    pertinence: {
      title: "Votre tapis a perdu son éclat ?",
      points: [
        "Les couleurs sont ternes et les motifs effacés",
        "Des taches se sont incrustées dans les fibres",
        "Les fibres sont écrasées et aplaties",
        "Votre tapis dégage une odeur désagréable",
        "Vous craignez d'abîmer un tapis de valeur",
      ],
    },
    emotion: {
      title: "Ce que vous risquez en attendant",
      points: [
        "Les fibres s'abîment de façon irréversible sans entretien",
        "Un tapis persan ou oriental perd sa valeur sans nettoyage adapté",
        "Les allergènes s'accumulent et affectent votre santé",
        "Le coût d'un tapis de qualité : plusieurs centaines à milliers de CHF",
        "Le nettoyage professionnel préserve votre investissement",
      ],
    },
    desir: {
      title: "Imaginez votre tapis restauré",
      points: [
        "Couleurs retrouvées, motifs visibles à nouveau",
        "Fibres relevées, souplesse restaurée",
        "Valeur de votre tapis préservée",
        "Un intérieur plus sain et plus beau",
        "La fierté d'un tapis entretenu par un professionnel",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Identification", desc: "Analyse des fibres et du type de tapis" },
        { num: "2", title: "Traitement adapté", desc: "Produits doux spécifiques à chaque fibre" },
        { num: "3", title: "Nettoyage délicat", desc: "Technique adaptée — pas de haute pression" },
        { num: "4", title: "Contrôle", desc: "Vérification avec vous, conseils d'entretien" },
      ],
      footer: "Technique adaptée à chaque fibre • Produits doux • Résultat garanti",
    },
  },
  "nettoyage-vitres": {
    heroSub: "Vitres cristallines, sans traces. Intérieur et extérieur. La lumière revient chez vous.",
    pertinence: {
      title: "Vos vitres manquent de transparence ?",
      points: [
        "Des traces persistent malgré vos efforts",
        "Le calcaire s'est incrusté sur les vitres extérieures",
        "La lumière naturelle est diminuée dans vos pièces",
        "Vos baies vitrées ou velux sont difficiles d'accès",
        "L'image de votre commerce ou bureau en souffre",
      ],
    },
    emotion: {
      title: "Ce que des vitres sales coûtent réellement",
      points: [
        "La lumière naturelle diminuée impacte votre bien-être",
        "Des vitres sales donnent une image négligée à votre bien",
        "Le calcaire attaque le verre et crée des dégâts permanents",
        "Le nettoyage amateur laisse des traces et vous fait perdre du temps",
        "Le nettoyage professionnel : résultat impeccable, gain de temps",
      ],
    },
    desir: {
      title: "Imaginez des vitres parfaitement transparentes",
      points: [
        "Lumière naturelle retrouvée dans chaque pièce",
        "Aucune trace, aucune marque",
        "Une façade qui reflète votre professionnalisme",
        "Protection hydrophobe : vos vitres restent propres plus longtemps",
        "Plus de temps perdu à nettoyer vous-même",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Évaluation", desc: "Nombre de vitres, accessibilité, état" },
        { num: "2", title: "Nettoyage", desc: "Technique professionnelle, intérieur et extérieur" },
        { num: "3", title: "Traitement", desc: "Option anti-traces et protection hydrophobe" },
        { num: "4", title: "Contrôle", desc: "Vérification vitre par vitre avec vous" },
      ],
      footer: "3 formules disponibles • Intérieur + extérieur • Résultat sans traces garanti",
    },
  },
  "nettoyage-terrasse": {
    heroSub: "Votre terrasse retrouve sa beauté. Haute pression + traitement anti-mousse professionnel.",
    pertinence: {
      title: "Votre terrasse montre des signes d'usure ?",
      points: [
        "La mousse et le verdissement envahissent la surface",
        "La terrasse est devenue glissante et dangereuse",
        "La couleur d'origine a disparu sous les salissures",
        "Le bois a grisé et perdu son éclat",
        "Vous n'osez plus y recevoir vos invités",
      ],
    },
    emotion: {
      title: "Ce que vous risquez en attendant",
      points: [
        "Une terrasse couverte de mousse = risque de chute pour votre famille",
        "La mousse et l'humidité dégradent le matériau en profondeur",
        "La valeur de votre bien immobilier diminue visiblement",
        "Le remplacement d'une terrasse : 100 à 300 CHF/m²",
        "Le nettoyage + protection : dès 15 CHF/m² seulement",
      ],
    },
    desir: {
      title: "Imaginez votre terrasse comme au premier jour",
      points: [
        "Surface propre et sécurisée pour toute la famille",
        "Couleurs d'origine retrouvées",
        "Prête pour les barbecues et apéros entre amis",
        "Protection longue durée contre la mousse",
        "La fierté de montrer votre extérieur",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Diagnostic", desc: "Évaluation du matériau (béton ou bois) et de l'état" },
        { num: "2", title: "Nettoyage", desc: "Haute pression adaptée au matériau" },
        { num: "3", title: "Traitement", desc: "Application anti-mousse ou protection longue durée" },
        { num: "4", title: "Contrôle", desc: "Vérification et conseils d'entretien" },
      ],
      footer: "3 formules (nettoyage, traitement, protection) • Béton et bois • Résultat immédiat",
    },
  },
  "nettoyage-chaises": {
    heroSub: "Chaises en tissu rafraîchies en un passage. Dès 7 CHF par chaise.",
    pertinence: {
      title: "Vos chaises en tissu ont besoin d'un coup de neuf ?",
      points: [
        "Les assises sont tachées par les repas quotidiens",
        "Le tissu a grisé et perdu son éclat",
        "Des odeurs s'incrustent malgré le nettoyage",
        "L'ensemble de votre salle à manger semble défraîchi",
        "Vous hésitez entre remplacer et nettoyer",
      ],
    },
    emotion: {
      title: "Pourquoi agir maintenant",
      points: [
        "Des chaises tachées dégradent l'ambiance de chaque repas",
        "Les bactéries et allergènes s'accumulent dans le tissu",
        "Remplacer un lot de 6 chaises : 500 à 2'000 CHF",
        "Le nettoyage professionnel de 6 chaises : 42 CHF seulement",
        "Un investissement minime pour un résultat spectaculaire",
      ],
    },
    desir: {
      title: "Imaginez vos chaises comme neuves",
      points: [
        "Tissu frais et couleurs ravivées",
        "Plus aucune tache, plus aucune odeur",
        "Une salle à manger accueillante et propre",
        "Le plaisir de recevoir sans gêne",
        "Un entretien simple et économique",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Évaluation", desc: "Inspection du tissu et des taches" },
        { num: "2", title: "Pré-traitement", desc: "Traitement ciblé des taches" },
        { num: "3", title: "Nettoyage", desc: "Injection-extraction rapide et efficace" },
        { num: "4", title: "Résultat", desc: "Chaises sèches et utilisables en quelques heures" },
      ],
      footer: "Dès 7 CHF/chaise • Tarif dégressif • Résultat rapide",
    },
  },
  "nettoyage-fauteuils": {
    heroSub: "Fauteuils rembourrés nettoyés en profondeur. Confort et fraîcheur retrouvés.",
    pertinence: {
      title: "Votre fauteuil mérite un nettoyage professionnel ?",
      points: [
        "Le tissu est taché par l'usure quotidienne",
        "Une odeur s'est installée dans le rembourrage",
        "Les couleurs ont terni avec le temps",
        "Le fauteuil est devenu le repaire de vos animaux",
        "Vous envisagez de le remplacer",
      ],
    },
    emotion: {
      title: "Avant de remplacer, considérez ceci",
      points: [
        "Un fauteuil de qualité se nettoie, il ne se jette pas",
        "Les bactéries et acariens s'accumulent dans le rembourrage",
        "Le coût d'un fauteuil neuf : 500 à 2'000 CHF",
        "Le nettoyage professionnel : dès 40 CHF",
        "Le résultat vous surprendra",
      ],
    },
    desir: {
      title: "Imaginez votre fauteuil restauré",
      points: [
        "Confort retrouvé, tissu frais",
        "Couleurs ravivées comme au premier jour",
        "Un salon dont vous êtes fier",
        "Un environnement sain et agréable",
        "Économie substantielle vs remplacement",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Diagnostic", desc: "Évaluation du tissu et des zones à traiter" },
        { num: "2", title: "Pré-traitement", desc: "Traitement ciblé des taches et odeurs" },
        { num: "3", title: "Nettoyage", desc: "Injection-extraction professionnelle" },
        { num: "4", title: "Contrôle", desc: "Vérification du résultat avec vous" },
      ],
      footer: "Dès 40 CHF • Tarif dégressif • Tous types de fauteuils",
    },
  },
  _default: {
    heroSub: "Intervention professionnelle avec résultat garanti. Devis gratuit sous 2 heures.",
    pertinence: {
      title: "Un nettoyage professionnel s'impose ?",
      points: [
        "L'état de la surface se dégrade visiblement",
        "Les solutions maison ne suffisent plus",
        "L'image de votre bien en souffre",
        "Vous souhaitez préserver la valeur de votre investissement",
        "Vous cherchez un professionnel fiable en Suisse romande",
      ],
    },
    emotion: {
      title: "Pourquoi ne pas attendre",
      points: [
        "La dégradation est progressive et s'accélère avec le temps",
        "Le coût de remplacement dépasse largement celui du nettoyage",
        "L'image de votre bien impacte sa valeur immobilière",
        "Un nettoyage professionnel prolonge la durée de vie de vos surfaces",
        "Chaque jour qui passe aggrave le problème",
      ],
    },
    desir: {
      title: "Imaginez le résultat",
      points: [
        "Des surfaces propres et entretenues professionnellement",
        "La valeur de votre bien préservée",
        "Un environnement sain et agréable",
        "La tranquillité d'esprit d'un travail bien fait",
        "La satisfaction d'un résultat visible immédiatement",
      ],
    },
    methode: {
      steps: [
        { num: "1", title: "Évaluation", desc: "Diagnostic gratuit de vos besoins" },
        { num: "2", title: "Préparation", desc: "Sélection des produits et techniques adaptés" },
        { num: "3", title: "Intervention", desc: "Nettoyage professionnel en profondeur" },
        { num: "4", title: "Contrôle", desc: "Vérification du résultat et conseils" },
      ],
      footer: "Équipement professionnel • Produits écologiques • Résultat garanti",
    },
  },
};

export function getLandingContent(serviceSlug) {
  return LANDING_CONTENT[serviceSlug] || LANDING_CONTENT._default;
}
